var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewCampaign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "campaigns",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,16 L18,12 L18,16 L22,16 L18,16 Z M18,16 L18,19.762207 L18,16 L14.237793,16 L18,16 Z",
    id: "Combined-Shape",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73418361,1.04166667 L8.81751691,4.16666667 L18.75,4.16666667 C19.3252966,4.16666667 19.7916666,4.63303663 19.7916666,5.208333 L19.7916666,11.8921356 L21.875,11.8921356 L21.875,5.208333 C21.875,3.48244334 20.4758898,2.08333333 18.75,2.08333333 L9.93248309,2.08333333 L7.84914979,-1.04166666 L2.0833333,-1.04166666 C0.357443529,-1.04166666 -1.04166666,0.357443344 -1.04166666,2.083333 L-1.04166666,16.666667 C-1.04166666,18.3925567 0.357443529,19.7916667 2.0833333,19.7916667 L13.75,19.7916667 L13.75,17.7083333 L2.0833333,17.7083333 C1.50803669,17.7083333 1.04166666,17.2419634 1.04166666,16.666667 L1.04166666,2.083333 C1.04166666,1.50803663 1.50803669,1.04166666 2.0833333,1.04166666 L6.73418361,1.04166667 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCampaign);
export default __webpack_public_path__ + "static/media/newCampaign.1a19171c7fb91bb493a86bc6b17c6f08.svg";
export { ForwardRef as ReactComponent };